module.exports = __webpack_public_path__ + "krecove-zily_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_5_after.jpg
// module id = 1033
// module chunks = 0